<template>
	<div style="overflow-x: hidden !important; overflow-y: hidden">
		<div class="main">
			<div style="padding: 10px; margin-top: 15px">
				<div class="header">
					<div class="header_title-container title">
						<h1>{{ this.folder }}</h1>
						<h5>{{ computedDocNumber }}</h5>
					</div>
					<div class="header_actions" style="margin-top: 20px">
						<div class="header_actions-container">
							<search
								:loadDocs="true"
								:loadFolders="false"
								:folderID="$route.params.folder_id"
								from="browse-documents"
								@docSelected="
									item => {
										handleSearch(item.value)
									}
								"
								@folderSelected="item => {}"
								@keyup="
									str => {
										handleSearch(str)
									}
								"
							/>
						</div>
					</div>
				</div>

				<div class="documents infinite-list-wrapper" style="overflow: auto">
					<div
						class="documents_container list"
						v-infinite-scroll="scrollLoad"
						:infinite-scroll-disabled="scrollDisabled"
						infinite-scroll-distance="50"
						style="margin-bottom: 100px"
					>
						<div v-if="expired">
							<div
								style="
									display: flex;
									width: 100%;
									justify-content: space-around;
									align-items: center;
									height: 100%;
								"
							>
								<div>
									<md-icon class="md-size-2x" style="color: #f56c6c">warning</md-icon>
								</div>
								<div style="font-size: 1.2em; margin-left: 10px; font-weight: 500">
									{{ $t("expired-subscription-content") }}
								</div>
							</div>
						</div>
						<div
							v-for="d in docs"
							:key="d.id"
							@mouseover="mousein(d.id)"
							@mouseleave="mouseout(d.id)"
							class="documents_wrapper list-item"
							v-else
						>
							<div class="documents_upper">
								<div class="documents_thumb">
									<!-- <div :ref="'rnd_' + d.id">
										<Renderer
											v-if="d.preview !== undefined"
											:key="uuid()"
											:valore="d.preview[0].items[0]"
											:dati="d.preview"
										></Renderer>
										<div v-else>{{ $t("preview-not-available") }}</div>
									</div> -->
									<div :ref="'rnd_' + d.id" style="display: flex; height: 100%">
										<md-icon class="md-size-5x" style="color: #1a73e8">description</md-icon>
									</div>

									<div :ref="'opt_' + d.id" style="display: none">
										<div>
											<el-button
												type="primary"
												icon="el-icon-view"
												style="width: 100%; margin-top: 5px"
												plain
												@click="viewInfo(d.id, d.unique)"
												>{{ $t("see-more") }}
											</el-button>
										</div>
										<div>
											<el-button
												type="primary"
												icon="el-icon-plus"
												style="width: 100%; margin-top: 5px"
												plain
												@click="
													docId = d.id
													documentPopup = !documentPopup
												"
												>{{ $t("add-to-project") }}
											</el-button>
										</div>
									</div>
								</div>
							</div>
							<div class="documents_details">
								<div class="documents_details-infos">
									<div class="documents_details-title">{{ d.title }}</div>
									<div class="documents_details-time">{{ d.time }}</div>
									<div>
										<el-tag
											v-for="area in d.areas"
											:key="area.id"
											style="margin-left: 3px; margin-bottom: 3px"
											type="success"
										>
											{{ area.area.name }}
										</el-tag>
										<el-tag
											v-for="tag in d.tags"
											:key="tag.id"
											style="margin-left: 3px; margin-bottom: 3px"
										>
											{{ tag.tag.name }}
										</el-tag>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- render modal -->
				<el-dialog
					:key="showModalRender + uuid()"
					:title="$t('preview')"
					:visible.sync="showModalRender"
					@close="
						showModalRender = false
						openSidebar(true)
						setSidebar('')
					"
					width="80%"
					:custom-class="'custom-dialog'"
				>
					<span slot="title">
						<i class="el-icon-document" style="margin-right: 10px"></i>{{ $t("preview") }}
					</span>
					<anteprima
						v-if="showModalRender"
						:key="showModalRender + uuid()"
						:doc_id="selected_to_prev"
						:unique="selected_to_prev_unique"
						:logged="true"
					></anteprima>
					<span slot="footer">
						<el-button
							type="success"
							@click="
								showModalRender = !showModalRender
								documentPopup = !documentPopup
							"
							>{{ $t("add-to-project") }}</el-button
						>
						<el-button
							style="margin-left: 20px"
							type="primary"
							@click="
								showModalRender = false
								openSidebar(true)
								setSidebar('')
							"
						>
							{{ $t("close") }}</el-button
						>
					</span>
				</el-dialog>

				<div class="float-center">
					<div class="float-content-spinner" v-if="scrollLoading">
						<i class="el-icon-loading" />
					</div>
					<div
						class="float-content"
						v-bind:class="{ visible: scrollNoMoreSnackbar, hidden: !scrollNoMoreSnackbar }"
					>
						<div class="float-text">{{ $t("no-more-docs") }}</div>
					</div>
				</div>

				<add-document :show="documentPopup" @close="documentPopup = !documentPopup" :docId="docId" />
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios"
import { uuid } from "@/modules/builder/utils/utils"
import Renderer from "@/modules/builder/components/Renderer"
import ButtonCollapseSidebar from "@/modules/_common/button/button-collapse-sidebar.vue"
import FoldersSidebar from "@/modules/browse/components/sidebar-components/browse-sidebar.vue"
import AddDocument from "@/modules/browse/components/modals/browse-add-document"
import Anteprima from "@/modules/documents/anteprima"
import { mapMutations } from "vuex"
import Search from "@/modules/browse/components/search"

export default {
	name: "browse-documents",
	components: {
		Renderer,
		ButtonCollapseSidebar,
		FoldersSidebar,
		AddDocument,
		Anteprima,
		Search
	},
	data() {
		return {
			folder: "",
			docsNumber: 0,
			docs: [],
			widthScreen: window.innerWidth - 150,
			sidebar: true || window.innerWidth < 900,
			showModalRender: false,
			inFolder: false,
			docsSearch: "",
			selected_nodes: [],
			documentPopup: false,
			docId: undefined,
			scrollLoading: false,
			scrollNoMoreSnackbar: false,
			scrollEnded: false,
			tilesNumber: 1,
			rowsToLoad: 4,
			loadedPages: 0,
			idx: undefined,
			selected_to_prev: undefined,
			selected_to_prev_unique: undefined,
			expired: false
		}
	},
	watch: {
		idx() {
			this.docsSearch = ""
			this.loadedPages = 0
			this.scrollEnded = false
			this.docs = []
			this.getDocPage()
		},
		"$route.params.folder_id"() {
			this.docsSearch = ""
			this.loadedPages = 0
			this.scrollEnded = false
			this.docs = []
			this.load()
		},
		scrollNoMoreSnackbar() {
			if (this.scrollNoMoreSnackbar) {
				setTimeout(() => {
					this.scrollNoMoreSnackbar = false
				}, 3000)
			}
		}
	},
	computed: {
		computedDocNumber: function () {
			return this.$t("documents-counter").replace("%DOCSNUMBER%", this.docsNumber)
		},
		folderID() {
			if (
				this.$route.params.folder_id == "all" ||
				this.$route.params.folder_id == undefined ||
				this.$route.params.folder_id == 0
			)
				return ""
			else return this.$route.params.folder_id
		},
		scrollDisabled() {
			return this.scrollLoading || this.scrollEnded
		}
	},
	created() {
		if (this.$route.params.doc_id) {
			this.idx = this.$route.params.doc_id
		}
		this.tilesNumber = Math.floor((this.widthScreen - 90) / 340)
		this.load()
	},
	methods: {
		...mapMutations({
			openSidebar: "documents/TOGGLE_SIDEBAR",
			setSidebar: "documents/SIDEBAR_CONTENT"
		}),
		uuid,
		scrollLoad() {
			this.loadedPages++
			this.getDocPage()
		},
		load() {
			this.inFolder = false
			if (this.$route.params.folder_id == "all" || this.$route.params.folder_id == undefined)
				this.folder = this.$t("browse-documents")
			else if (this.$route.params.folder_id == 0) this.folder = this.$t("no-folder-generic")
			else {
				this.inFolder = true
				axios(`${process.env.VUE_APP_API_URL}/api/folders/${this.$route.params.folder_id}`, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
					.then(({ data: { name } }) => (this.folder = name))
					.catch(err => {
						this.folder = this.$t("no-folder-generic")
						console.error(err)
					})
			}
			this.getDocPage()
		},
		// TODO perché era stata messa asincrona?
		/*async*/ getDocPage() {
			const payload = {
				pagination: {
					offset: this.loadedPages * this.tilesNumber * this.rowsToLoad,
					size: this.rowsToLoad * this.tilesNumber
				},
				search: this.docsSearch.toLowerCase(),
				folder_id: this.$route.params.folder_id
			}
			if (!this.scrollEnded) {
				this.scrollLoading = true
				const url = `${process.env.VUE_APP_API_URL}/api/flowchart/getBySubscription`
				/*await*/ axios
					.post(url, payload, { headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` } })
					.then(res => {
						if (res.data.flowcharts === 0) this.expired = true
						if (res.data.flowcharts) {
							this.docsNumber = res.data.total
							res.data.flowcharts.forEach(f => {
								this.docs.push({
									id: f.Id,
									title: f.Title,
									preview: f.Preview ? [{ items: [JSON.parse(f.Preview.json)] }] : undefined,
									areas: f.Areas,
									tags: f.Tags,
									unique: f.UniqueID
								})
							})
						}
						this.scrollLoading = false

						if (res.data.flowcharts.length == 0) {
							this.scrollNoMoreSnackbar = true
							this.scrollEnded = true
						}
					})
					.catch(err => {
						this.scrollLoading = false
						this.scrollNoMoreSnackbar = true
						this.scrollEnded = true
					})
			} else {
				this.scrollNoMoreSnackbar = true
			}
		},

		mousein(i) {
			const elHide = this.$refs[`rnd_${i}`][0]
			const elShow = this.$refs[`opt_${i}`][0]
			elHide.style.display = "none"
			elShow.style.cssText =
				"display:flex; flex-direction: column; justify-content: space-around; height: 100%; padding: 15px !important;"
		},
		mouseout(i) {
			const elHide = this.$refs[`opt_${i}`][0]
			const elShow = this.$refs[`rnd_${i}`][0]
			elHide.style.display = "none"
			elShow.style.cssText = "display: flex; height: 100%"
		},
		viewInfo(id, unique) {
			this.docId = id
			axios(`${process.env.VUE_APP_API_URL}/api/flowchart/getSaved/${id}`, {
				headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
			})
				.then(({ data }) => {
					this.selected_nodes = data.items.dati.map((el, index) => {
						if (el.value) {
							let tttmp = { id: 0, items: [], name: "" }
							el.value.forEach(el78 => {
								tttmp.items.push(JSON.parse(el78.items))
							})
							el.value = [tttmp]
						}
						el.id = index
						return el
					})
					this.selected_to_prev = id
					this.selected_to_prev_unique = unique
					this.showModalRender = true
				})
				.catch(() => this.$notification("warning", this.$t("warning"), this.$t("generic-error-msg")))
		},
		handleSearch(searchstr) {
			this.docsSearch = searchstr
			this.loadedPages = 0
			this.scrollEnded = false
			this.scrollLoading = false
			this.scrollNoMoreSnackbar = false
			this.docs = []
			this.getDocPage()
		}
	}
}
</script>
<style>
.custom-dialog {
	margin-top: 10vh !important;
}
</style>
<style scoped lang="scss">
@import "@/assets/scss/documents.scss";
@import "src/assets/scss/collapse-button";

.menu {
	font-family: "Montserrat", sans-serif;
	z-index: 2;
	position: absolute;
	left: 0;
	bottom: 0;
	top: 63px;
	width: 150px;
	background-color: #455a64;
	transition: width 0.5s;
}

.main {
	height: calc(100vh - 100px);
	display: flex;
	flex-direction: column;
	margin-top: -25px;
}

.float-content-spinner {
	width: 50px;
	height: 50px;
	font-size: 40px;
	background-color: rgba(214, 214, 214, 0.459);
	border-radius: 50px;
	padding-top: 5px;
	transform: translate(-25px);
}

.float-content {
	width: 300px;
	height: 30px;
	transform: translate(-150px);
	background-color: rgba(214, 214, 214, 0.459);
	border-radius: 50px;
}

.visible {
	visibility: visible;
	opacity: 1;
}

.hidden {
	visibility: hidden;
	opacity: 0;
	transition: visibility 0s 1s, opacity 1s linear;
}

.float-text {
	padding-top: 5px;
}
</style>
